import { startTransition } from 'react';
import { NavigateOptions, useNavigate, useParams } from 'react-router-dom';

export const useCustomNavigate = () => {
  const { lang } = useParams();
  const navigate = useNavigate();

  const customNavigate = (path: string, options?: NavigateOptions) => {
    startTransition(() => {
      navigate(`/${lang}/${path}`, options);
    });
  };

  return customNavigate;
};
